/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'

export default function Model(props) {
  const { nodes, materials } = useGLTF('assets/glb-file/40.glb')
  return (
    <group {...props} dispose={null}>
      <group scale={0.1}>
        <mesh geometry={nodes.w_glasses31.geometry} material={nodes.w_glasses31.material} position={[0, 0, -0.05]} />
      </group>
    </group>
  )
}

//useGLTF.preload('assets/glb-file/40.glb')
